import {
  Divider,
  Illustration,
  type IllustrationType,
  Text,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface BasePerkProps {
  illustration: IllustrationType;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  includeDividerBelow?: boolean;
}

export function BasePerk(props: BasePerkProps) {
  const { illustration, title, description, includeDividerBelow } = props;

  return (
    <Stack direction="column" alignItems="left" gap={5}>
      <Stack direction="row" alignItems="top" gap={5}>
        <Illustration type={illustration} />
        <Stack direction="column" alignItems="left" gap={1}>
          <Text semibold textAlign="left" variant="body1">
            {title}
          </Text>
          <Text textAlign="left" variant="body2" color={(theme) => theme.palette.text.secondary}>
            {description}
          </Text>
        </Stack>
      </Stack>
      {includeDividerBelow && <Divider color="subtle" />}
    </Stack>
  );
}
